module.exports = __webpack_public_path__ + "static/media/pod_activeEffect.0c621844.png";